import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { lego } from '@zz-common/lego';
import { getUrlParams, getCookie, isZLJUrl, urlFormatter, getShareMessage, setCookie, getPPU, request, formartChooseAddressRes, compareVersion, getZZVersion, addQuery } from "../../core/utils";
import BaseAdapter from "../base/BaseAdapter";
var ZLJAdapterPlatform = [
// 找靓机app的旧webview
{
  rule: /zhaoliangji[^-]/,
  name: 'zlj'
},
// 找靓机app老的webview，但是ua写错的情况
{
  rule: function rule() {
    return /zhaoliangji-v2/.test(navigator.userAgent) && getUrlParams().needNewWebview != '1' && getUrlParams().needNewWebView != '1' && compareVersion(getCookie('v'), '9.1.10') < 0;
  },
  name: 'zlj'
}];

// 找靓机旧webview
var ZLJAdapter = /*#__PURE__*/function (_BaseAdapter) {
  _inherits(ZLJAdapter, _BaseAdapter);
  var _super = _createSuper(ZLJAdapter);
  function ZLJAdapter(native) {
    var _this;
    _classCallCheck(this, ZLJAdapter);
    return _this = _super.call(this, native, 'https://s1.zhuanstatic.com/common/zlj-js-sdk/static/js/1.1.4/zlj-js-sdk.min.js', function () {
      _this.zlj = window.zlj;
      _this.__sdk = _this.zlj;

      // 转换同步的api为回调函数形式，保持zlj所有的api调用形式一致
      _this.transformAPI();
    });
  }
  _createClass(ZLJAdapter, [{
    key: "transformAPI",
    value: function transformAPI() {
      var _this2 = this;
      var API_LIST = ['getContextInfo', 'checkThird', 'checkLogin', 'getSystemExtraInfo'];
      API_LIST.forEach(function (item) {
        var originFun = _this2.__sdk[item];
        _this2.__sdk[item] = function () {
          var argv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var params = argv.params || [];
          if (!argv.success) {
            console.warn('找靓机APP中，getContextInfo,checkThird,checkLogin,getSystemExtraInfo五个方法进行了特殊处理，请调用这几个API时候，传入参数 { success: (res) => {console.log(res)} }， 在success回调中拿到结果');
          }
          var r = originFun.apply(_this2.__sdk, params);
          console.log(r);
          argv.success && argv.success(r);
        };
      });
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo(callback) {
      if (typeof callback !== 'function') {
        callback = callback.success;
      }
      callback && callback(this.zlj.getUserInfo());
    }
  }, {
    key: "enterHome",
    value: function enterHome() {
      this.skipToUrl({
        targetUrl: 'zljgo://native_api?type=132'
      });
    }
  }, {
    key: "setTitle",
    value: function setTitle(obj) {
      var title = obj.title;
      this.zlj.changeTitle(title);
    }
  }, {
    key: "share",
    value: function share(shareMessage, callback) {
      this.zlj.setShareInfo(Object.assign(getShareMessage(shareMessage), {
        type: 6,
        success: function success() {
          callback && callback({
            code: '0'
          });
        },
        fail: function fail() {
          callback && callback({
            code: '-1'
          });
        }
      }));
    }
  }, {
    key: "shareClick",
    value: function shareClick(shareMessage, callback) {
      this.zlj.showSharePanel(Object.assign(getShareMessage(shareMessage), {
        type: 6,
        success: function success() {
          callback && callback({
            code: 0
          });
        },
        fail: function fail() {
          callback && callback({
            code: -1
          });
        }
      }));
    }
  }, {
    key: "skipToUrl",
    value: function () {
      var _skipToUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(obj) {
        var _this3 = this;
        var targetUrl, _obj$extra, extra, _obj$needClose, needClose;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              targetUrl = obj.targetUrl, _obj$extra = obj.extra, extra = _obj$extra === void 0 ? {} : _obj$extra, _obj$needClose = obj.needClose, needClose = _obj$needClose === void 0 ? 0 : _obj$needClose;
              targetUrl = addQuery(targetUrl, extra);
              targetUrl = urlFormatter(targetUrl);
              needClose == 1 && this.zlj.setCloseMark({
                marks: location.href
              });
              if (isZLJUrl(targetUrl)) {
                location.href = targetUrl;
              } else {
                location.href = "zljgo://native_api?type=1&content=".concat(encodeURIComponent(targetUrl));
              }
              needClose == 1 && setTimeout(function () {
                _this3.zlj.closeByMarkArray({
                  marks: [location.href]
                });
              }, 300);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function skipToUrl(_x) {
        return _skipToUrl.apply(this, arguments);
      }
      return skipToUrl;
    }()
  }, {
    key: "login",
    value: function login(callback) {
      var _this4 = this;
      var skipSetPPU;
      if (_typeof(callback) === 'object') {
        skipSetPPU = callback.skipSetPPU;
        callback = callback.callback;
      }
      lego.send({
        pagetype: 'PAGE_LOG_PPU',
        actiontype: 'LOGIN_START',
        backup: {
          uid: getCookie('uid'),
          ppu: getCookie('PPU')
        }
      });
      this.zlj.login({
        data: {
          dialog: '1'
        },
        success: function success(data) {
          lego.send({
            pagetype: 'PAGE_LOG_PPU',
            actiontype: 'LOGIN_SUCCESS_0',
            backup: {
              uid: getCookie('uid'),
              ppu: getCookie('PPU')
            }
          });
          if (skipSetPPU) {
            return callback && callback(_objectSpread(_objectSpread({}, data), {}, {
              code: '0'
            }));
          }
          var token = data.token,
            userId = data.userId;
          // 如果token就是ppu格式，那么直接埋入即可
          if (token.indexOf('UID=') > -1 && document.domain.indexOf('zhuanzhuan.com') > -1) {
            lego.send({
              pagetype: 'PAGE_LOG_PPU',
              actiontype: 'LOGIN_SUCCESS_1',
              backup: {
                uid: getCookie('uid'),
                ppu: getCookie('PPU')
              }
            });
            setCookie('uid', getPPU(token).UID);
            setCookie('PPU', "\"".concat(token, "\""));
            lego.send({
              pagetype: 'PAGE_LOG_PPU',
              actiontype: 'LOGIN_SUCCESS_2',
              backup: {
                uid: getCookie('uid'),
                ppu: getCookie('PPU')
              }
            });
            callback && callback(_objectSpread(_objectSpread({}, data), {}, {
              code: '0'
            }));
            return;
          }
          var opts = {
            // url: 'https://kfimentry.zhuanzhuan.com/info/kfim/through/zljUserLogin',
            url: 'https://app.zhuanzhuan.com/zzx/transfer/getPpuByZLJToken',
            method: 'get',
            params: {
              zljToken: encodeURIComponent(token),
              zljUid: userId
            },
            csrfToken: false
          };
          lego.send({
            pagetype: 'PAGE_LOG_PPU',
            actiontype: 'LOGIN_SUCCESS_3',
            backup: {
              uid: getCookie('uid'),
              ppu: getCookie('PPU')
            }
          });
          request(opts).then(function (res) {
            var _res$respData = res.respData,
              uid = _res$respData.uid,
              ppuStr = _res$respData.ppuStr;
            lego.send({
              pagetype: 'PAGE_LOG_PPU',
              actiontype: 'LOGIN_SUCCESS_4',
              backup: {
                uid: getCookie('uid'),
                ppu: getCookie('PPU'),
                res: res.respData
              }
            });
            setCookie('uid', uid);
            setCookie('PPU', "\"".concat(ppuStr, "\""));
            callback && callback(_objectSpread(_objectSpread({}, data), {}, {
              code: '0'
            }));
          }).catch(function (e) {
            lego.send({
              pagetype: 'PAGE_LOG_PPU',
              actiontype: 'LOGIN_SUCCESS_5',
              backup: {
                uid: getCookie('uid'),
                ppu: getCookie('PPU')
              }
            });
            callback && callback({
              code: '-1'
            });
            _this4.zlj.logout();
          });
        },
        fail: function fail() {
          lego.send({
            pagetype: 'PAGE_LOG_PPU',
            actiontype: 'LOGIN_FAIL',
            backup: {
              uid: getCookie('uid'),
              ppu: getCookie('PPU')
            }
          });
          callback && callback({
            code: '-1'
          });
        }
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.zlj.closeWindow();
    }
  }, {
    key: "chooseAddress",
    value: function chooseAddress() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      var addressId = obj.addressId,
        closeTag = obj.closeTag;
      var isThan9_1_85 = compareVersion(getZZVersion(), '9.1.85') >= 0;
      var params = Object.assign({
        addressId: addressId || 0,
        success: function success(res) {
          try {
            callback && callback(formartChooseAddressRes(res));
          } catch (error) {
            console.log(error);
          }
        },
        fail: function fail(res) {
          callback && callback(res);
        }
      }, isThan9_1_85 ? {
        closeTag: closeTag || '0'
      } : {});
      this.zlj.chooseReceiveAddress(params);
    }
  }, {
    key: "getQRCodeScan",
    value: function getQRCodeScan() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (args.length > 1) {
        this.zlj.qrCodeScan(function (res) {
          args[1]({
            code: res && res.qrCode ? '0' : -1,
            resultString: res.qrCode || '',
            resultStr: res.qrCode || '',
            msg: ''
          });
        });
      } else {
        this.zlj.qrCodeScan(function (res) {
          args[0]({
            code: res && res.qrCode ? '0' : -1,
            resultString: res.qrCode || '',
            resultStr: res.qrCode || '',
            msg: ''
          });
        });
      }
    }
  }, {
    key: "setPageBackAction",
    value: function setPageBackAction() {
      this.zlj.openBlockBack(true);
    }
  }, {
    key: "uploadPhotos",
    value: function uploadPhotos(obj, callback) {
      obj.maxAllowCount = obj.maxAllowCount || '5';
      this.zlj.uploadPhotos(obj, callback);
    }
  }]);
  return ZLJAdapter;
}(BaseAdapter);
_defineProperty(ZLJAdapter, "pluginName", 'ZLJAdapter');
_defineProperty(ZLJAdapter, "platform", ZLJAdapterPlatform);
export { ZLJAdapter as default };